<template>
  <div>
    <div id="surveyCreatorContainerPage"></div>

    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('page_template_information') }}</h4>
      <ValidationObserver ref="pageTemplateForm">
        <form>

          <ValidationProvider name="title" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.title" :placeholder="$t('title')" :label="$t('title')"></fg-input>
          </ValidationProvider>

          <fg-input :label="$t('select_content_type')">
            <el-select size="large" class="select-primary" filterable clearable
              v-model="form.contentType_ID" :placeholder="$t('select_content_type')">
              <el-option
                v-for="item in contentTypes"
                :key="item.id" 
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </fg-input>

        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{$t('sancel')}}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="info" link @click="createPageTemplate">{{$t('create_page_template')}}</p-button>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>
import * as SurveyCreator from "survey-creator";
import "survey-creator/survey-creator.css";
import * as SurveyKo from "survey-knockout";
import * as widgets from "surveyjs-widgets";
import Modal from "src/components/UIComponents/Modal.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";

import { init as GridWidget } from "./GridWidget.js";
import { init as CategoriesWidget } from "./CategoriesWidget.js";
GridWidget(SurveyKo);
CategoriesWidget(SurveyKo);
widgets.ckeditor(SurveyKo);

import { savePageTemplate } from '@/util/Api/pageTemplate.js';
import Resource from "@/util/Api/resource.js";
const CategoryResource = new Resource("category");
export default {
  name: "CreatePageTemplateBuilder",
  components: {
    Modal,
    PSwitch
  },
  data() {
    return {
      modals: {
        classic: false
      },
      form: {
        title: '',
        postTemplate:'',
        contentType_ID: '',
        otherFields:'',
      },
      pages: [],
      formName: "",
      formContent: "",
      categories: [],
      contentTypes:[],
    };
  },

  created() {
    this.getCategories();
  },


  mounted() {
    SurveyCreator.StylesManager.applyTheme("bootstrap");

    let options = {};

    let surveyCreator = new SurveyCreator.SurveyCreator("surveyCreatorContainerPage", options);

    surveyCreator.showToolbox = "right";
    surveyCreator.showPropertyGrid = "right";
    surveyCreator.rightContainerActiveItem("toolbox");

    surveyCreator.haveCommercialLicense = true;
    const vm = this;

    surveyCreator.saveSurveyFunc = function() {
      const formContent = JSON.parse(this.text);
      vm.openUpdateModal(formContent);
    };

  },


  methods: {
    // message dialog
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    // reset forms
    resetForm() {
      this.form.title = "";
      this.$refs.pageTemplateForm.reset();
    },

    // function to close modal
    handleCloseModal() {
      this.modals.classic = false;
      this.resetForm();
    },

    // function to open modal
    openUpdateModal(formContent) {
      this.modals.classic = true;
      this.formContent = formContent;
    },

    // Get all content types
    async getCategories() {
      await CategoryResource.list({})
        .then(response => {
          this.categories = response.data;
          this.categories.forEach((value) => {
             if(value.name.toLowerCase().includes("content type")) {
                this.contentTypes = value.children;
             }
          });
        }).catch(error => {
          console.log("error occured");
        });
    },

    // create page template function
    async createPageTemplate() {
      let formData = new FormData();
      formData.append("title", this.form.title);
      formData.append("otherFields", this.form.otherFields);
      formData.append("postTemplate", JSON.stringify(this.formContent));
      formData.append("contentType_ID", this.form.contentType_ID);

      await savePageTemplate(formData)
        .then(response => {
          this.showAlertMessage(this.$t("page_template_created_successfully"), "success")
          this.$router.push({name: "PageBuilderIndex"});
        }).catch(error => {
          if (error.response.data.error) {
            this.$refs.formBuilderForm.setErrors(error.response.data.error.message);
          }
      });
    }

  }
};
</script>
